/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-cond-assign */
import emojiArray from './emoji-array';

export interface TextNode {
  type: 'text';
  text: string;
  index: number;
}

export interface URLNode {
  type: 'url';
  text: string;
  url: string;
  protocol: string;
  index: number;
}

export interface EmojiNode {
  type: 'emoji';
  index: number;
  text: string;
  imageUrl: string;
}

export interface DrefNode {
  type: 'dref';
  children: Node[];
  attributes: { [key: string]: string };
  index: number;
}

interface Fragment {
  type: 'fragment';
  children: Node[];
  attributes: { [key: string]: string };
  index: number;
}

type InlineNode = EmojiNode | TextNode | URLNode;

type BlockNode = DrefNode | Fragment;

export type Node = InlineNode | BlockNode;

interface TextToken {
  type: 'text_token';
  raw: string;
}

interface URLToken {
  type: 'url_token';
  raw: string;
  protocol: string;
}

interface EmojiToken {
  type: 'emoji_token';
  raw: string;
}

interface DrefOpenToken {
  type: 'dref_open_token';
  raw: string;
  rawAttributes: string;
}

interface DrefCloseToken {
  type: 'dref_close_token';
  raw: string;
}

interface DrefSelfCloseToken {
  type: 'dref_self_close_token';
  raw: string;
  rawAttributes: string;
}

type Token = TextToken | URLToken | EmojiToken | DrefOpenToken | DrefCloseToken | DrefSelfCloseToken;

function genEmojiRegexp() {
  const textArr: string[] = Object.keys(emojiArray as any).map((t) => t.replace(/([[\]])/g, '\\$1'));
  const joined = textArr.join('|');

  return [new RegExp(`^(${joined})`), new RegExp(`${joined}`, 'g')];
}

function getEmojiImageUrl(text: string): string {
  return (emojiArray as any)[text] || '';
}

const [, EMOJI_REGEXP_GLOBAL] = genEmojiRegexp();
const EMOJI_REGEXP = /^\[[^[\]\\]+\]/;
const DREF_OPEN_REGEXP = /^<dref([^<>]*)>/;
const DREF_OPEN_REGEXP_GLOBAL = /<dref([^<>]*)>/g;
const DREF_CLOSE_REGEXP = /^<\/dref>/;
const DREF_CLOSE_REGEXP_GLOBAL = /<\/dref>/g;
const DREF_SELF_CLOSE_REGEXP = /^<dref([^<>]*)\/>/;
const DREF_SELF_CLOSE_REGEXP_GLOBAL = /<dref([^<>]*)\/>/g;
const URL_REGEXP =
  /^(http|ftp|https|blob|chrome|file):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/;
const PLAIN_TEXT_REGEXP = /^([^<>[\]\\](?!(http:\/\/|https:\/\/|ftp:\/\/|blob:\/\/|chrome:\/\/|file:\/\/)))+/;

export function tokenization(text: string): Token[] {
  let rest = text;
  const tokens: Token[] = [];

  if (!text || text.length === 0) {
    return tokens;
  }

  let accText = '';
  let isEscape = false;

  let maxLoop = 40;

  const consumeTextTokenAndEscape = (raw: string) => {
    if (isEscape) {
      accText = accText.slice(0, -1);
      accText += raw;
      isEscape = false;
    } else {
      if (accText) {
        tokens.push({
          type: 'text_token',
          raw: accText,
        });
        accText = '';
      }
      return true;
    }
    return false;
  };

  while (rest.length > 0) {
    let match;
    if ((match = rest.match(DREF_SELF_CLOSE_REGEXP))) {
      // 匹配自闭合标签
      if (consumeTextTokenAndEscape(match[0])) {
        tokens.push({
          type: 'dref_self_close_token',
          raw: match[0],
          rawAttributes: match[1],
        });
      }
      rest = rest.slice(match[0].length);
    } else if ((match = rest.match(DREF_OPEN_REGEXP))) {
      // 匹配开标签
      if (consumeTextTokenAndEscape(match[0])) {
        tokens.push({
          type: 'dref_open_token',
          raw: match[0],
          rawAttributes: match[1],
        });
      }

      rest = rest.slice(match[0].length);
    } else if ((match = rest.match(DREF_CLOSE_REGEXP))) {
      // 匹配闭标签
      if (consumeTextTokenAndEscape(match[0])) {
        tokens.push({ type: 'dref_close_token', raw: match[0] });
      }
      rest = rest.slice(match[0].length);
    } else if ((match = rest.match(EMOJI_REGEXP))) {
      if ((emojiArray as any)[match[0]]) {
        // 匹配 emoji
        if (consumeTextTokenAndEscape(match[0])) {
          tokens.push({ type: 'emoji_token', raw: match[0] });
        }
        rest = rest.slice(match[0].length);
      } else {
        // 消耗一个字符
        accText += match[0][0];
        rest = rest.slice(1);
      }
    } else if ((match = rest.match(URL_REGEXP))) {
      // 匹配 URL
      if (consumeTextTokenAndEscape(match[0])) {
        tokens.push({ type: 'url_token', raw: match[0], protocol: match[1] });
      }
      rest = rest.slice(match[0].length);
    } else if ((match = rest.match(PLAIN_TEXT_REGEXP))) {
      // 匹配不含特殊字体的文本
      accText += match[0];
      rest = rest.slice(match[0].length);
    } else {
      // 处理剩余情况
      accText += rest[0];

      if (rest[0] === '\\') {
        if (isEscape) {
          accText = accText.slice(0, -1);
          isEscape = false;
        } else {
          isEscape = true;
        }
      }

      rest = rest.slice(1);
    }

    maxLoop -= 1;
    if (maxLoop <= 0) {
      console.error('rich text tokenization: max loop exceeded: ', text);
      accText += rest;
      break;
    }
  }

  if (accText) {
    tokens.push({
      type: 'text_token',
      raw: accText,
    });
  }

  return tokens;
}

export function escape(text: string) {
  return text
    .replace(DREF_SELF_CLOSE_REGEXP_GLOBAL, '\\$&')
    .replace(DREF_OPEN_REGEXP_GLOBAL, '\\$&')
    .replace(DREF_CLOSE_REGEXP_GLOBAL, '\\$&')
    .replace(EMOJI_REGEXP_GLOBAL, '\\$&');
}

export function parseAttributes(text: string): { [key: string]: string } {
  if (!text || text.length === 0) {
    return {};
  }

  const pairs = text.split(/\s+/);

  const ret: { [key: string]: string } = {};

  for (const pair of pairs) {
    const [key, value] = pair.split('=');
    ret[key] = value;
  }

  return ret;
}

export function stringifyAttributes(obj: { [key: string]: string | number }): string {
  if (!obj) return '';
  let ret = '';
  for (const key in obj) {
    ret += ` ${key}=${obj[key]}`;
  }
  return ret;
}

export function parseTokens(tokens: Token[]): Node {
  const root: Fragment = {
    type: 'fragment',
    children: [],
    attributes: {},
    index: 0,
  };

  const _tokens = [...tokens];

  if (_tokens.length === 0) {
    return root;
  }

  const stack: Token[] = [];
  const path: BlockNode[] = [root];

  while (_tokens.length > 0) {
    const tHead = _tokens.shift() as Token;

    if (tHead.type === 'dref_open_token') {
      stack.push(tHead);
      const drefNode: DrefNode = {
        type: 'dref',
        children: [],
        attributes: parseAttributes(tHead.rawAttributes.trim()),
        index: path[0].children.length,
      };
      path[0].children.push(drefNode);
      path.unshift(drefNode);
    } else if (tHead.type === 'dref_close_token') {
      const sHead = stack.pop();
      if (!sHead) {
        throw new Error('parse dref error');
      }
      path.shift();
    } else if (tHead.type === 'dref_self_close_token') {
      const drefNode: DrefNode = {
        type: 'dref',
        children: [],
        attributes: parseAttributes(tHead.rawAttributes.trim()),
        index: path[0].children.length,
      };
      path[0].children.push(drefNode);
    } else if (tHead.type === 'text_token') {
      path[0].children.push({
        type: 'text',
        text: tHead.raw,
        index: path[0].children.length,
      });
    } else if (tHead.type === 'emoji_token') {
      path[0].children.push({
        type: 'emoji',
        text: tHead.raw,
        index: path[0].children.length,
        imageUrl: getEmojiImageUrl(tHead.raw),
      });
    } else if (tHead.type === 'url_token') {
      path[0].children.push({
        type: 'url',
        text: tHead.raw,
        url: tHead.raw,
        protocol: tHead.protocol,
        index: path[0].children.length,
      });
    }
  }

  if (root.children.length === 1) {
    return root.children[0];
  }

  return root;
}

function createDefaultAst(text: string): Node {
  return {
    type: 'text',
    text,
    index: 0,
  };
}

export function createFragment(children: Node | Node[]): Fragment {
  if (!Array.isArray(children)) {
    children = [children];
  }
  return {
    type: 'fragment',
    children,
    attributes: {},
    index: 0,
  };
}

export function parse(text: string): Node {
  const tokens = tokenization(text);
  try {
    return parseTokens(tokens);
  } catch (e) {
    console.warn(e);
    return createDefaultAst(text);
  }
}

export function stringify(root: Node | Node[]): string {
  let ret = '';

  if (Array.isArray(root)) {
    root = createFragment(root);
  }

  if (root.type === 'text') {
    return root.text;
  }
  if (root.type === 'emoji') {
    return root.text;
  }
  if (root.type === 'dref') {
    for (const child of root.children) {
      ret += stringify(child);
    }
    ret = `<dref${stringifyAttributes(root.attributes)}>${ret}</dref>`;
  } else if (root.type === 'fragment') {
    for (const child of root.children) {
      ret += stringify(child);
    }
  }
  return ret;
}

type TraverseFn = (node: Node, path: BlockNode[], excludeSet: Set<Node>) => void;

function _traverse(
  root: Node,
  fn?: TraverseFn,
  path: BlockNode[] = [],
  pathSet: Set<BlockNode> = new Set(),
  excludeSet: Set<Node> = new Set(),
  maxLoopRef: { c: number } = { c: 2000 }
) {
  if (excludeSet.has(root)) {
    return;
  }

  if (pathSet.has(root as BlockNode)) {
    console.error('rich text traverse dead loop at: ', root);
    return;
  }

  maxLoopRef.c -= 1;
  if (maxLoopRef.c <= 0) {
    console.error('rich text traverse max loop exceeded: ', path[0]);
    return;
  }

  if (root.type === 'text') {
    fn && fn(root, path, excludeSet);
  } else if (root.type === 'emoji') {
    fn && fn(root, path, excludeSet);
  } else if (root.type === 'url') {
    fn && fn(root, path, excludeSet);
  } else {
    fn && fn(root, path, excludeSet);
    path.push(root);
    pathSet.add(root);
    for (const child of root.children) {
      _traverse(child, fn, path, pathSet, excludeSet, maxLoopRef);
    }
    path.pop();
    pathSet.delete(root);
  }
}

export function traverse(root: Node, fn?: TraverseFn) {
  return _traverse(root, fn);
}
